// extracted by mini-css-extract-plugin
export default {"searchArea":"search-area__searchArea___vgzr3","searchIcon":"search-area__searchIcon___lHOpy","searchAreaInput":"search-area__searchAreaInput___unxOr"};